
/* injects from baggage-loader */

'use strict';

/**
 * Directive for show or hide spinner loader.
 *
 * @export
 * @param {shared.module} app
 */
export default function (app) {

	/**
	 * Function that define if the spinner loader is showing or hiding.
	 *
	 * @returns
	 */
	function loaderDirective (){
		return showOrHideLoader;
	}

	/**
	 * Function that show or hide the spinner loader.
	 *
	 * @param {any} $rootScope
	 * @param {any} element
	 * @returns
	 */
	function showOrHideLoader($rootScope, element) {
		'ngInject';

		$rootScope.$on("loader_show", () => {
			return element.removeClass('hidden');
		});

		return $rootScope.$on("loader_hide", () => {
			return element.addClass('hidden');
		});
	}

	app.directive('loader', loaderDirective);
}



// WEBPACK FOOTER //
// ./src/app/core/directives/loader.directive.js